import { motion } from "framer-motion";

const STORIA_IMG =
  "https://images.unsplash.com/photo-1515823662972-da6a2e4d3002?crop=entropy&cs=srgb&fm=jpg&q=85";

const MILESTONES = [
  {
    year: "1995",
    title: "Il laboratorio 'Loran'",
    text: "Lorenzo Pisoni trasforma la sua passione per la pasticceria in realtà, aprendo il primo laboratorio e punto vendita a Mezzocorona.",
  },
  {
    year: "1999",
    title: "Nasce San Vigilio",
    text: "La voglia di crescere e innovare porta alla nascita della Pasticceria San Vigilio, nel cuore del centro storico di Trento.",
  },
  {
    year: "Oggi",
    title: "Tradizione che continua",
    text: "Ingredienti scelti con cura, attenzione in ogni preparazione e una passione per la pasticceria che ci accompagna ogni giorno.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Storia = () => (
  <section id="storia" className="py-24 sm:py-32" data-testid="storia-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
        <div className="relative lg:sticky lg:top-28">
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            className="relative rounded-3xl overflow-hidden aspect-[4/5] max-w-md"
          >
            <img
              src={STORIA_IMG}
              alt="Brioche artigianali e caffè espresso"
              className="w-full h-full object-cover"
              loading="lazy"
              data-testid="storia-image"
            />
          </motion.div>
          <motion.div
            variants={fadeUp}
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="absolute -bottom-6 -right-2 sm:right-6 lg:-right-8 bg-[#84232a] text-[#fbf6f1] rounded-2xl px-7 py-5 shadow-xl"
            data-testid="storia-years-badge"
          >
            <span className="font-display text-4xl font-semibold">30</span>
            <span className="block text-xs uppercase tracking-[0.2em] mt-1 opacity-80">
              anni di passione
            </span>
          </motion.div>
        </div>

        <div>
          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="text-xs uppercase tracking-[0.3em] font-semibold text-[#84232a] mb-4"
            data-testid="storia-eyebrow"
          >
            La nostra storia
          </motion.p>
          <motion.h2
            variants={fadeUp}
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="font-display text-4xl sm:text-5xl font-semibold text-black leading-tight"
            data-testid="storia-title"
          >
            Da Mezzocorona al cuore di Trento,{" "}
            <span className="font-script text-[#84232a] font-normal">con amore.</span>
          </motion.h2>
          <motion.p
            variants={fadeUp}
            custom={2}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="text-[#4a423d] text-base sm:text-lg leading-relaxed mt-6"
            data-testid="storia-text"
          >
            Dal 1999, Pasticceria San Vigilio è un luogo dove ogni giorno
            nascono dolci, sapori e piccoli momenti da condividere. Portiamo
            avanti la tradizione della pasticceria artigianale con passione e
            attenzione, scegliendo con cura ogni dettaglio e cercando sempre di
            offrire qualcosa di speciale a chi entra da noi. Perché per noi un
            dolce non è solo qualcosa di buono da mangiare, ma un momento da
            ricordare.
          </motion.p>

          <div className="mt-12 space-y-0">
            {MILESTONES.map((m, i) => (
              <motion.div
                key={m.year}
                variants={fadeUp}
                custom={i}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-60px" }}
                className="group flex gap-6 sm:gap-8 border-t border-[#e6dacb] py-7 last:border-b"
                data-testid={`storia-milestone-${i}`}
              >
                <span className="font-display text-3xl sm:text-4xl font-semibold text-[#84232a] w-20 sm:w-24 shrink-0">
                  {m.year}
                </span>
                <div>
                  <h3 className="font-display text-xl sm:text-2xl font-semibold text-black">
                    {m.title}
                  </h3>
                  <p className="text-[#4a423d] text-sm sm:text-base mt-2 leading-relaxed">
                    {m.text}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
